<template>
  <DataPage
    ref="entitiesTable"
    :columns="columns"
    :filters="filters"
    :title="__('entities.list')"
    :pre-title="__('entities.pre-title')"
    :fetch-callback="fetchEntities"
    :model="EntityModel"
    has-row-actions
  >
    <template #pageActions>
      <b-button
        v-can:entities.create
        variant="primary"
        size="sm"
        data-testid="create-entity-btn"
        @click="handleCreateEntity"
      >
        <Icon icon="plus-circle" size="14" class="mr-2" />
        {{ __('entities.create') }}
      </b-button>
    </template>

    <template #name="{ item }">
      <RouterLink
        :to="{ name: 'entities.show', params: { entityId: item.id } }"
      >
        {{ item.name }}
      </RouterLink>
    </template>

    <template #parent="{ item }">
      <Badge :variant="item.isGroup ? 'soft-success' : 'soft-danger'">
        {{ item.isGroup ? __('common.yes') : __('common.no') }}
      </Badge>
    </template>

    <template #type="{ item }">
      <Badge :variant="item.typeData().badge">
        {{ item.typeData().short }}
      </Badge>
    </template>

    <template #status="{ item }">
      <Badge :variant="item.statusData().badge">
        {{ __(item.statusData().label) }}
      </Badge>
    </template>

    <template #usersCount="{ item }">
      {{
        item.isChild
          ? item.usersCount + item.subsidiaryEntityUsersCount
          : item.usersCount
      }}
    </template>

    <template #actionButtons="{ item }">
      <ActionPopover
        :id="item.id"
        v-can-any="['entities.update', 'entities.destroy']"
      >
        <b-button
          v-can:entities.update
          class="dropdown-item"
          size="sm"
          @click="handleEdit(item.id)"
        >
          <Icon icon="edit" class="mr-2" size="14" />
          {{ __('buttons.edit') }}
        </b-button>

        <b-button
          v-can:entities.destroy
          class="dropdown-item"
          size="sm"
          @click="remove(item.id)"
        >
          <Icon icon="trash" class="mr-2" size="14" />
          {{ __('buttons.remove') }}
        </b-button>
      </ActionPopover>
    </template>
  </DataPage>
</template>

<script>
import DataPage from '@/General/Tables/DataPage.vue'
import { FILTER_TAB, OPERATOR_ACTION } from '@/General/Tables/FilterManager.js'
import EntityModel from '@/Modules/Entity/EntityModel.js'
import EntityService from '@/Modules/Entity/EntityService.js'
import CreateEntityModal from '@/Modules/Entity/Components/CreateEntityModal.vue'

export default {
  name: 'List',

  components: { DataPage },

  data() {
    return {
      EntityModel: EntityModel,

      columns: [
        {
          column: 'code',
          title: this.__(`common.reference`),
          sortable: true,
        },
        {
          column: 'name',
          title: this.__(`common.name`),
          sortable: true,
          custom: true,
        },
        {
          column: 'legalName',
          title: this.__(`common.legal-name`),
          sortable: true,
        },
        {
          column: 'address',
          title: this.__(`address.address`),
        },
        {
          column: 'parent',
          title: this.__(`common.parent`),
          custom: true,
        },
        {
          column: 'type',
          title: this.__(`common.type`),
          custom: true,
        },
        {
          column: 'usersCount',
          title: this.__(`menu.users`),
          custom: true,
        },
        {
          column: 'status',
          title: this.__(`common.status`),
          custom: true,
        },
      ],

      filters: [
        {
          type: FILTER_TAB,
          operator: OPERATOR_ACTION,
          options: [
            {
              value: 'all',
              label: this.__(`entities.all`),
              default: true,
            },
            {
              value: 'coverholders',
              label: this.__(`entities.coverholder`),
            },
            {
              value: 'agents',
              label: this.__(`common.agent`),
            },
            {
              value: 'insurers',
              label: this.__(`entities.insurer`),
            },
          ],
        },
      ],
    }
  },

  methods: {
    fetchEntities(parameters) {
      return EntityService.list(parameters)
    },

    remove(id) {
      this.$showConfirmationModal(
        this.__(`entities.delete-confirmation`),
        () => {
          EntityService.delete(id)
            .then(() => {
              this.$successToast(this.__(`entities.delete-success`))
              this.$refs.entitiesTable.refreshTable()
            })
            .catch((error) => {
              this.$errorToast(error.response.data.message)
            })
        }
      )
    },

    handleCreateEntity() {
      this.showModal({
        component: CreateEntityModal,
        label: this.__(`entities.create`),
        icon: 'entity',
        class: 'modal-md',
        showExpand: true,
        onSuccess: () => {
          this.$refs.entitiesTable.refreshTable()
        },
      })
    },

    handleEdit(id) {
      if (!id) {
        console.warn(this.__(`entities.id`), typeof id)
        return
      }
      EntityService.show(id).then((entity) => {
        this.showModal({
          component: CreateEntityModal,
          label: this.__(`entities.update`),
          icon: 'entity',
          class: 'modal-md',
          showExpand: true,
          meta: {
            entity,
          },
          onSuccess: () => {
            this.$refs.entitiesTable.refreshTable()
          },
        })
      })
    },
  },
}
</script>
